import { noop } from 'lodash';
import { createContext, useContext } from 'react';

export interface PageContextValue {
  readonly isContentPanelOpen: boolean;
  readonly shouldDisplayContentPanelButton: boolean;
  readonly showContentSidebarAriaLabel: string;
  closeContentPanel(): void;
  openContentPanel(): void;
}

export const defaultValue: PageContextValue = {
  isContentPanelOpen: false,
  shouldDisplayContentPanelButton: false,
  showContentSidebarAriaLabel: '',
  closeContentPanel: noop,
  openContentPanel: noop,
};

export const PageContext = createContext<PageContextValue>(defaultValue);

type UsePageContext = () => PageContextValue;
export const usePageContext: UsePageContext = () => useContext(PageContext);
